// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  background-color: #fff;
}
.streams-drawer .streams-drawer-wrapper {
  margin-top: 56px;
  display: grid;
  height: calc(100% - 56px);
  grid-template-columns: minmax(232px, 1fr) repeat(auto-fit, 232px) minmax(232px, 1fr);
  grid-template-rows: 100%;
  grid-gap: 0 16px;
  overflow-y: auto;
}
.streams-drawer .streams-drawer-wrapper.list {
  grid-template-columns: minmax(232px, 1fr) repeat(auto-fit, calc(720px + 32px)) minmax(232px, 1fr);
}
.streams-drawer .streams-drawer-wrapper.carousel {
  grid-template-columns: 232px minmax(0, 1fr);
}
.streams-drawer .streams-drawer-wrapper .streams-sidebar {
  grid-column: 1;
  overflow-y: auto;
  width: 232px;
}
.streams-drawer .streams-drawer-wrapper .streams-content {
  grid-column-start: 2;
  grid-column-end: -2;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.streams-drawer .streams-drawer-wrapper .streams-content > .header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.streams-drawer .streams-drawer-wrapper .streams-drawer-summary-view {
  margin-right: 16px;
}
.streams-drawer .streams-drawer-wrapper .streams-drawer-standard-view {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}
.streams-drawer .streams-drawer-wrapper .streams-drawer-standard-view .streams-drawer-content-view {
  overflow: scroll;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.streams-drawer .streams-drawer-wrapper .streams-drawer-standard-view .streams-drawer-loading-view {
  display: flex;
  justify-content: center;
  align-items: center;
}
.streams-drawer .streams-drawer-wrapper .streams-drawer-standard-view streams-drawer-content {
  display: block;
  height: 100%;
}
.streams-drawer .streams-drawer-wrapper .filters-sidebar {
  justify-self: end;
  overflow-y: auto;
}
.streams-drawer .streams-drawer-wrapper .filters-sidebar .collections-closable-sidebar-filters {
  overflow-y: scroll;
  border-left: 1px solid #dbdee0;
  min-height: 100%;
}
.streams-drawer .streams-drawer-wrapper .block-image img {
  display: block;
  height: auto;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  width: auto;
}
.streams-drawer .setup-container {
  margin-top: 72px;
  overflow: auto;
}
.streams-drawer .gutter-right {
  padding-right: 7px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer/streams-drawer.less"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAJF;AAHA;EAUI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,oFAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,iGAAA;AAJN;AAOI;EACE,2CAAA;AALN;AAlBA;EA2BM,cAAA;EACA,gBAAA;EACA,YAAA;AANN;AAvBA;EAiCM,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAPN;AA9BA;EAwCQ,aAAA;EACA,sBAAA;EACA,QAAA;AAPR;AAnCA;EA+CM,kBAAA;AATN;AAtCA;EAmDM,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;AAVN;AA5CA;EAyDQ,gBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AAVR;AAlDA;EAgEQ,aAAA;EACA,uBAAA;EACA,mBAAA;AAXR;AAvDA;EAsEQ,cAAA;EACA,YAAA;AAZR;AA3DA;EA4EM,iBAAA;EACA,gBAAA;AAdN;AA/DA;EAgFQ,kBAAA;EACA,8BAAA;EACA,gBAAA;AAdR;AApEA;EAwFQ,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAjBR;AA5EA;EAmGI,gBAAA;EACA,cAAA;AApBJ;AAhFA;EAuGI,kBAAA;AApBJ","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n@import (reference) '../../../css/unison';\n\n.streams-drawer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: @cu-zindex-modal;\n  background-color: @cu-white;\n\n  .streams-drawer-wrapper {\n    margin-top: 56px;\n    display: grid;\n    height: calc(~\"100% - 56px\");\n    grid-template-columns: minmax(@cu-small-measure, 1fr) repeat(auto-fit, @cu-small-measure) minmax(@cu-small-measure, 1fr);\n    grid-template-rows: 100%;\n    grid-gap: @cu-spacing-0 @cu-spacing-3;\n    overflow-y: auto;\n\n    &.list {\n      grid-template-columns: minmax(@cu-small-measure, 1fr) repeat(auto-fit, calc(@cu-container-max-width-md + 32px)) minmax(@cu-small-measure, 1fr);\n    }\n\n    &.carousel {\n      grid-template-columns: @cu-small-measure minmax(0, 1fr);\n    }\n\n    .streams-sidebar {\n      grid-column: 1;\n      overflow-y: auto;\n      width: @cu-small-measure;\n    }\n\n    .streams-content {\n      grid-column-start: 2;\n      grid-column-end: -2;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n\n      > .header {\n        display: flex;\n        flex-direction: column;\n        gap: @cu-spacing-2;\n      }\n    }\n\n    .streams-drawer-summary-view {\n      margin-right: @cu-spacing-3;\n    }\n\n    .streams-drawer-standard-view {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      flex: 1;\n\n      .streams-drawer-content-view {\n        overflow: scroll;\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n      }\n\n      .streams-drawer-loading-view {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      streams-drawer-content {\n        display: block;\n        height: 100%;\n      }\n    }\n\n    .filters-sidebar {\n      justify-self: end;\n      overflow-y: auto;\n\n      .collections-closable-sidebar-filters {\n        overflow-y: scroll;\n        border-left: 1px solid @cu-gray-2;\n        min-height: 100%;\n      }\n    }\n\n    .block-image {\n      img {\n        display: block;\n        height: auto;\n        margin: auto;\n        max-height: 100%;\n        max-width: 100%;\n        width: auto;\n      }\n    }\n  }\n\n  .setup-container {\n    margin-top: 72px;\n    overflow: auto;\n  }\n  .gutter-right{\n    padding-right:7px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
